// frontend/src/utils/handbookUtils.js
// Employee-facing helpers for handbook edition codes (YYYY.MM calendar releases).

const MONTH_SHORT = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

/**
 * Format a handbook edition code for employee-facing UI.
 *
 * Codes are calendar editions (e.g. "2026.08"), not software semver. Raw
 * "2026.08" next to an effective date reads like a second date — convert to
 * "Aug 2026" so Edition vs Effective Date are distinct.
 *
 * Args:
 *   code: Edition code from HandbookEdition / handbook meta (e.g. "2026.08")
 *
 * Returns:
 *   Human label (e.g. "Aug 2026"), or the original code if unparseable.
 */
export const formatHandbookEditionLabel = (code) => {
  if (!code || typeof code !== 'string') return '';
  const match = code.trim().match(/^(\d{4})\.(\d{1,2})$/);
  if (!match) return code;
  const year = match[1];
  const monthIndex = Number(match[2]) - 1;
  if (monthIndex < 0 || monthIndex > 11) return code;
  return `${MONTH_SHORT[monthIndex]} ${year}`;
};
